import type { Task, TaskPinBoard } from "@storyboard/web-client";
import { store } from "@/store/store";

/**
 * Upserts tasks into the store.
 *
 * Keyed on the id, so a sync re-serving rows near its cursor writes the same values again, and the server's echo of an
 * optimistic task replaces the client's estimated `createdAt` with the stored one.
 */
export function upsertTasks(rows: readonly Task[]): void {
  if (rows.length === 0) return;
  store.upsert("task", rows);
}

/**
 * Upserts task pins into the store, keyed on the id as {@link upsertTasks} keys tasks.
 */
export function upsertTaskPinBoards(rows: readonly TaskPinBoard[]): void {
  if (rows.length === 0) return;
  store.upsert("taskPinBoard", rows);
}

/** Removes tasks the server dropped or never recorded, so an optimistic task does not linger. */
export function removeTasks(ids: readonly string[]): void {
  if (ids.length === 0) return;
  store.delete("task", ids);
}

/** Removes pins the server dropped or never recorded, so an optimistic move does not linger. */
export function removeTaskPinBoards(ids: readonly string[]): void {
  if (ids.length === 0) return;
  store.delete("taskPinBoard", ids);
}
